import React, { useEffect, useState } from 'react';
import { Card, CardTitle } from '../components/UI';
import { listCarriers } from '../api';
import { Loader2 } from 'lucide-react';

export default function Carriers() {
  const [carriers, setCarriers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setCarriers(await listCarriers());
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Card>
      <CardTitle>Carrier matching</CardTitle>
      <p className="mb-4 text-sm leading-relaxed" style={{ color: 'var(--lf-muted)' }}>
        MVP concept: rank qualified carriers using rate, equipment, service area, historical
        on-time performance and capacity.
      </p>
      {loading ? (
        <div className="flex items-center gap-2 text-sm" style={{ color: 'var(--lf-muted)' }}>
          <Loader2 className="animate-spin" size={14} /> Loading…
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[13px] border-collapse">
            <thead>
              <tr>
                {['Carrier', 'Match', 'Rate', 'On-time'].map((h) => (
                  <th
                    key={h}
                    className="text-left p-3 font-semibold"
                    style={{ borderBottom: '1px solid var(--lf-line)' }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {carriers.map((c) => (
                <tr key={c.id}>
                  <td className="p-3 font-medium" style={{ borderBottom: '1px solid var(--lf-line)' }}>
                    {c.name}
                  </td>
                  <td className="p-3" style={{ borderBottom: '1px solid var(--lf-line)' }}>
                    <div className="flex items-center gap-2">
                      <div
                        className="w-24 h-1.5 rounded-full overflow-hidden"
                        style={{ background: '#e9edf4' }}
                      >
                        <div
                          className="h-full"
                          style={{ background: 'var(--lf-green)', width: `${c.match}%` }}
                        />
                      </div>
                      <span className="font-semibold">{c.match}%</span>
                    </div>
                  </td>
                  <td className="p-3" style={{ borderBottom: '1px solid var(--lf-line)' }}>{c.rate}</td>
                  <td className="p-3" style={{ borderBottom: '1px solid var(--lf-line)' }}>{c.on_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
